export default __webpack_public_path__ + "static/media/clerk-status@3x.bc7cf4af.png";